import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import {
  CUSTOM_TOGGLE_SWITCH_EVENT,
  DISABLE_CAROUSEL_EVENT,
  ENABLE_CAROUSEL_EVENT,
  FORM_CLOSED_EVENT,
  FORM_SHOWED_EVENT,
  FORM_SUBMITTED_EVENT,
  NEXT_CLICK_EVENT,
  NEXT_CLIP_COMPLETE_EVENT,
  TIMELINE_MARK_CLICK_EVENT,
  TIMELINE_MARK_START_EVENT,
  X_RAY_CLICK_EVENT,
} from './constants/events';

import { usePlayerWidget } from './helpers';

function Player({ className = '', style = null, ...props }) {
  const LWP = usePlayerWidget(props.instanceKey);
  const containerRef = useRef(null);

  useEffect(() => {
    LWP.reInit({
      container: containerRef.current,
      playerPropsPassThrow: props.playerPropsPassThrow,
      video: props.video,
      clipSource: props.clipSource,
      listeners: props.listeners || {},
    });
  }, [props.video.mediaid]);

  useEffect(() => () => LWP.unmountPlayerContainer(), []);

  return <div ref={containerRef} className={className} style={style} />;
}

Player.propTypes = {
  instanceKey: PropTypes.string.isRequired,
  playerPropsPassThrow: PropTypes.shape({}).isRequired,
  video: PropTypes.shape({
    mediaid: PropTypes.string.isRequired,
  }).isRequired,
  clipSource: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  listeners: PropTypes.shape({
    [NEXT_CLICK_EVENT]: PropTypes.func,
    [NEXT_CLIP_COMPLETE_EVENT]: PropTypes.func,
    [X_RAY_CLICK_EVENT]: PropTypes.func,
    [ENABLE_CAROUSEL_EVENT]: PropTypes.func,
    [DISABLE_CAROUSEL_EVENT]: PropTypes.func,
    [FORM_SHOWED_EVENT]: PropTypes.func,
    [FORM_CLOSED_EVENT]: PropTypes.func,
    [FORM_SUBMITTED_EVENT]: PropTypes.func,
    [TIMELINE_MARK_CLICK_EVENT]: PropTypes.func,
    [TIMELINE_MARK_START_EVENT]: PropTypes.func,
    [CUSTOM_TOGGLE_SWITCH_EVENT]: PropTypes.func,
  }).isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

export default Player;
